import { useState } from "react";
import { Table, Space, Tag } from "antd";
import { useSelector } from "react-redux";
import SearchInput from "../../../components/utils/SearchInput";
import {
  dateFormatterUI6,
  stringSorter,
} from "../../../utils/helpers/dataHelper";
import { Loading } from "../../../utils/helpers/constants";
import RoundLoader from "../../../components/loader/RoundLoader";
import { replaceString } from "../../../utils/helpers/dataHelper";
import { filterData } from "../../../utils/helpers/dataHelper";
import { useHistory } from "react-router-dom";

const DocumentTable = ({ list }) => {
  const [filterKey, setFilterKey] = useState("");

  const history = useHistory();
  const {
    document: { attachDocumentLoading },
  } = useSelector(({ documentReducer }) => ({ document: documentReducer }));

  const handleSearch = (value) => {
    setFilterKey(value);
  };

  const viewDocument = (item) => {
    history.push({
      state: item,
      pathname: `/document-processing/tracking/${item.documentType}`,
    });
  };

  const columns = [
    {
      title: "Request Name",
      dataIndex: "documentType",
      // key: "documentType",
      render: (documentType) => <span>{replaceString(documentType)}</span>,
    },
    {
      title: "Processed Date",
      dataIndex: "updatedDate",
      key: "updatedDate",
      render: (updatedDate) => <span>{dateFormatterUI6(updatedDate)}</span>,
      sorter: (a, b) => stringSorter(a.updatedDate, b.updatedDate),
    },
    {
      title: "Status",
      dataIndex: "processingStatus",
      key: "processingStatus",
    },
    // {
    //   title: "TWD",
    //   dataIndex: "status",
    //   key: "status",
    // },

    {
      title: "View",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Tag
            color={"blue"}
            className="cursor-pointer"
            onClick={() => viewDocument(record)}
          >
            View
          </Tag>
        </Space>
      ),
    },
  ];

  const loadState = attachDocumentLoading === Loading.FETCHING;

  return (
    <div>
      <div className="flex justify-between items-center py-4 bg-white dark:bg-gray-800">
        <div></div>
        <SearchInput handleSearch={(value) => handleSearch(value)} />
      </div>
      {loadState ? (
        <RoundLoader />
      ) : (
        <>
          <Table
            columns={columns}
            // pagination={{}}
            // dataSource={list}
            dataSource={filterData(list, filterKey, ["documentType"])}
            scroll={{
              x: 500,
            }}
            sticky
          />
        </>
      )}
    </div>
  );
};

export default DocumentTable;
